/* Print Phuket – compound option picker.
   A product option whose values are "A · B · C" (see metafield ppk.compound) is shown as one
   selector per component. Only combinations that exist as Shopify variants can be chosen.
   The native picker stays in the DOM (hidden) and remains the single source of truth.
   Option images: metafield ppk.option_images = {component: {value: media id OR image file name stem}}.
   When the customer picks a value that has an image, the product gallery jumps to that image. */
(function () {
  if (customElements.get('pp-compound')) return;
  var SEP = ' · ';
  customElements.define('pp-compound', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      try {
        var data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (e) { return; }
      this.comps = data.components;
      this.images = data.images || null;
      this.values = data.values.map(function (v) { return v.split(SEP); });
      this.raw = data.values;
      this.current = (data.selected || data.values[0]).split(SEP);
      this.fieldset = document.getElementById(this.dataset.native);
      if (!this.fieldset || this.values.some(function (v) { return v.length !== data.components.length; })) {
        // structure mismatch -> fall back to native picker
        if (this.fieldset) this.fieldset.classList.remove('pp-native-hidden');
        return;
      }
      this.render();
    }
    allowed(i, prefix) {
      var out = [];
      this.values.forEach(function (v) {
        for (var k = 0; k < i; k++) if (v[k] !== prefix[k]) return;
        if (out.indexOf(v[i]) === -1) out.push(v[i]);
      });
      return out;
    }
    best(i, val) {
      // full combination containing val at i that keeps as many current choices as possible (earlier choices weigh more)
      var cur = this.current, n = this.comps.length, best = null, bestScore = -1;
      this.values.forEach(function (v) {
        if (v[i] !== val) return;
        var s = 0;
        for (var k = 0; k < n; k++) if (k !== i && v[k] === cur[k]) s += (n - k);
        if (s > bestScore) { bestScore = s; best = v; }
      });
      return best;
    }
    choose(i, val) {
      var next;
      if (this.allowed(i, this.current).indexOf(val) > -1) {
        next = this.current.slice(0, i); next[i] = val;
        for (var k = i + 1; k < this.comps.length; k++) {
          var ok = this.allowed(k, next);
          next[k] = ok.indexOf(this.current[k]) > -1 ? this.current[k] : ok[0];
        }
      } else {
        next = this.best(i, val); if (!next) return; next = next.slice();
      }
      var target = next.join(SEP);
      var input = Array.prototype.find.call(this.fieldset.querySelectorAll('input[type="radio"], option'), function (el) { return el.value === target; });
      if (!input) return;
      if (input.tagName === 'OPTION') { var sel = input.closest('select'); sel.value = target; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      this.current = next; this.render();
      this.showImage(this.comps[i], val);
    }
    showImage(comp, val) {
      var map = this.images && this.images[comp];
      var ref = map && map[val];
      if (!ref) return;
      var root = this.closest('product-info') || document;
      var g = root.querySelector('media-gallery[id^="MediaGallery-"]') || document.querySelector('media-gallery');
      if (!g || typeof g.setActiveMedia !== 'function') return;
      var items = Array.prototype.slice.call(g.querySelectorAll('.product__media-item[data-media-id]'));
      var byName = typeof ref === 'string';
      var hit = null, idx = -1;
      items.forEach(function (el, n) {
        if (hit) return;
        var match;
        if (byName) {
          var img = el.querySelector('img');
          var src = img ? (img.getAttribute('src') || '') + ' ' + (img.getAttribute('srcset') || '') + ' ' + (img.getAttribute('data-src') || '') : '';
          match = src.indexOf('/' + ref + '.') > -1 || src.indexOf('/' + ref + '_') > -1;
        } else {
          match = String(el.dataset.mediaId) === String(ref);
        }
        if (match) { hit = el; idx = el.dataset.mediaIndex !== undefined ? +el.dataset.mediaIndex : n; }
      });
      if (!hit) return;
      var mid = hit.dataset.mediaId;
      try { g.init(); g.setActiveMedia({ featured_media: { id: mid, position: idx + 1 } }); } catch (e) {}
    }
    shown(i) {
      // values of component i that exist together with the current first component (hides e.g. sizes of other shapes)
      var out = [], first = this.current[0];
      this.values.forEach(function (v) {
        if (i > 0 && v[0] !== first) return;
        if (out.indexOf(v[i]) === -1) out.push(v[i]);
      });
      return out;
    }
    render() {
      var self = this, html = '';
      this.comps.forEach(function (name, i) {
        var vals = self.shown(i), ok = self.allowed(i, self.current);
        html += '<div class="pp-comp" data-i="' + i + '"><div class="form__label"><span class="font-body-bolder">' + esc(name) + ':</span> ' +
          '<span class="text-subtext">' + esc(self.current[i]) + '</span></div>';
        if (vals.length > 1) {
          html += '<div class="pp-comp__btns" role="radiogroup" aria-label="' + esc(name) + '">';
          vals.forEach(function (v) {
            var on = v === self.current[i], na = ok.indexOf(v) === -1;
            html += '<button type="button" role="radio" class="pp-cbtn' + (on ? ' is-on' : '') + (na ? ' is-na' : '') + '" aria-checked="' + on + '" data-v="' + esc(v) + '"' +
              (na ? ' title="Not available with your current choices. Select it to switch to a compatible combination."' : '') + '>' + esc(v) + '</button>';
          });
          html += '</div>';
        }
        html += '</div>';
      });
      this.querySelector('.pp-compound__ui').innerHTML = html;
      this.querySelectorAll('.pp-cbtn').forEach(function (b) {
        b.addEventListener('click', function () {
          var i = +b.closest('.pp-comp').dataset.i;
          if (b.dataset.v !== self.current[i]) self.choose(i, b.dataset.v);
          else self.showImage(self.comps[i], b.dataset.v);
        });
      });
    }
  });
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
})();
